import React from "react";
import ReactDOM from "react-dom";
import Demo from "./demo";
import {
  StylesProvider,
  createGenerateClassName
} from "@material-ui/core/styles";

const generateClassName = createGenerateClassName({
  productionPrefix: "jss",
  disableGlobal: true
});

ReactDOM.render(
  <StylesProvider generateClassName={generateClassName}>
    <Demo />
  </StylesProvider>,
  document.querySelector("#root")
);
